export const verifyTabList = [
  // {
  //   label: "全部",
  //   value: "ALL"
  // },
  {
    label: "待我处理",
    value: "PENDING"
  },
  {
    label: "我创建的",
    value: "CREATED"
  },
  {
    label: "我已处理",
    value: "DEALTED"
  }
]

export const tableColumns = [
  {
    label: "审批名称",
    value: "name"
  },
  {
    label: "状态",
    value: "stateZh"
  },
  {
    label: "审批数据",
    value: "dataTitle"
  },
  {
    label: "审批路径",
    value: "dataPath"
  },
  {
    label: "审批结果",
    value: "passZh"
  },
  {
    label: "审批意见",
    value: "rejectReasonStr"
  },
  {
    label: "发起人",
    value: "user.name"
  },
  {
    label: "发起时间",
    value: "createAt"
  },
  {
    label: "审批人",
    value: "verifyUser.name"
  },
  {
    label: "完成时间",
    value: "finishAt"
  }
]

export const favoriteColumns = [
  {
    label: "应用",
    value: "appName"
  },
  {
    label: "工作表",
    value: "sheetName"
  },
  {
    label: "标题",
    value: "title"
  },
  {
    label: "备注",
    value: "description"
  },
  {
    label: "收藏时间",
    value: "createAt"
  }
]

export const searchableInfos = [
  {
    label: "应用",
    value: "appId"
  },
  {
    label: "工作表",
    value: "sheetId"
  },
  {
    label: "备注",
    value: "description"
  }
]

export const themeStyleMap = {
  standard: {
    background: "#edeff1",
    menu: "standard"
  },
  simple: {
    background: "#fff",
    menu: "simple"
  }
}
